"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var SisButtonComponent = /** @class */ (function () {
    function SisButtonComponent() {
        this.isShown = true;
        this.onClick = new core_1.EventEmitter();
        this.disabled = false;
    }
    SisButtonComponent.prototype.clickEvent = function () {
        var _this = this;
        this.disabled = true;
        setTimeout(function () {
            _this.disabled = false;
        }, 500);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisButtonComponent.prototype, "isShown", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisButtonComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisButtonComponent.prototype, "color", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisButtonComponent.prototype, "onClick", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisButtonComponent.prototype, "buttonMsg", void 0);
    SisButtonComponent = __decorate([
        core_1.Component({
            selector: 'sis-button',
            template: "\n        <button\n            mat-raised-button\n            *ngIf=\"isShown\"\n            [id]=\"id\"\n            [color]=\"color\"\n            [disabled]=\"disabled\"\n            (click)=\"clickEvent(); onClick.emit($event)\"\n        >\n            {{ buttonMsg | sisTranslateMessage | async }}\n        </button>\n    ",
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n        <sis-button\n            [id]=\"'%{id}'\"\n            [color]=\"%{color}\"\n            (onClick)=\"%{onClick}\"\n            [buttonMsg]=\"%{button_msg}\"\n            [isShown]=\"%{isShown}\">\n        </sis-button>\n    ",
        })
    ], SisButtonComponent);
    return SisButtonComponent;
}());
exports.SisButtonComponent = SisButtonComponent;
//# sourceMappingURL=sis-button.component.js.map